// extracted by mini-css-extract-plugin
export default {"container":"ingredients_container__gUs8D"};